"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _Transition = _interopRequireDefault(require("@instructure/ui-motion/lib/components/Transition"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'cDwzl',
  template: function template(theme) {
    return "\n\n.cDwzl_caGd,.cDwzl_bGBk{box-sizing:border-box}\n\n.cDwzl_caGd{background:".concat(theme.background || 'inherit', ";border-color:").concat(theme.borderColor || 'inherit', ";border-style:").concat(theme.borderStyle || 'inherit', ";border-width:").concat(theme.borderWidth || 'inherit', ";color:").concat(theme.color || 'inherit', ";width:100%}\n\n.cDwzl_cLQw{overflow:auto}\n\n.cDwzl_GKUc,.cDwzl_cAug{flex-basis:100%;min-width:1px}\n\n.cDwzl_GKUc .cDwzl_caGd,.cDwzl_cAug .cDwzl_caGd{border-bottom:none;border-left:none;border-right:none}");
  },
  'content': 'cDwzl_caGd',
  'root': 'cDwzl_bGBk',
  'overflow': 'cDwzl_cLQw',
  'minimal': 'cDwzl_GKUc',
  'simple': 'cDwzl_cAug'
};
var TabPanel = (
/**
---
parent: TabList
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TabPanel, _Component);

  function TabPanel() {
    (0, _classCallCheck2.default)(this, TabPanel);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabPanel).apply(this, arguments));
  }

  (0, _createClass2.default)(TabPanel, [{
    key: "renderContent",
    value: function renderContent() {
      var _classes;

      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.content, true), (0, _defineProperty2.default)(_classes, styles.overflow, this.props.maxHeight), _classes);
      return _react.default.createElement(_View.default, {
        className: (0, _classnames.default)(classes),
        maxHeight: this.props.maxHeight,
        as: "div",
        padding: this.props.padding,
        textAlign: this.props.textAlign
      }, this.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      var _classes2;

      var classes = (_classes2 = {}, (0, _defineProperty2.default)(_classes2, styles.root, true), (0, _defineProperty2.default)(_classes2, styles[this.props.variant], true), _classes2);
      var isHidden = !this.props.selected || !!this.props.disabled;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(classes),
        role: "tabpanel",
        id: this.props.id,
        "aria-labelledby": this.props.labelledBy,
        "aria-hidden": isHidden ? 'true' : null
      }, _react.default.createElement(_Transition.default, {
        type: "fade",
        in: !isHidden,
        unmountOnExit: true,
        transitionExit: false
      }, this.renderContent()));
    }
  }]);
  TabPanel.displayName = "TabPanel";
  return TabPanel;
}(_react.Component), _class2.propTypes = {
  /**
  * The content that will be rendered in the corresponding <Tab /> and will label
  * this `<TabPanel />` for screen readers
  */
  title: _propTypes.default.node.isRequired,
  children: _propTypes.default.node,
  variant: _propTypes.default.oneOf(['simple', 'minimal']),
  maxHeight: _propTypes.default.string,
  id: _propTypes.default.string,
  labelledBy: _propTypes.default.string,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  padding: _ThemeablePropTypes.default.spacing,
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),

  /**
  * A ref to this `<TabPanel />` component instance
  */
  tabRef: _propTypes.default.func
}, _class2.defaultProps = {
  children: null,
  maxHeight: void 0,
  disabled: false,
  textAlign: void 0,
  id: null,
  variant: 'simple',
  labelledBy: null,
  selected: false,
  padding: 'small',
  tabRef: function tabRef(el) {}
}, _temp)) || _class) || _class);
exports.default = TabPanel;